module.exports = __webpack_public_path__ + "media/icons/opony-zimowe-green@2x-7d6bd868.png";